/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityCommentDto } from '../../models/community-comment-dto';

export interface CommunityCommentControllerToggleBlocked$Params {
  id: string;
}

export function communityCommentControllerToggleBlocked(http: HttpClient, rootUrl: string, params: CommunityCommentControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityCommentDto>> {
  const rb = new RequestBuilder(rootUrl, communityCommentControllerToggleBlocked.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunityCommentDto>;
    })
  );
}

communityCommentControllerToggleBlocked.PATH = '/api/community-comments/{id}/toggle-blocked';
